
import html2canvas from 'html2canvas';
import submitDialog from '@/components/submitDialog/submitDialog.vue'
import {mapActions, mapMutations} from 'vuex'
import axios from 'axios'
import md5 from 'md5'
import { getBaseUrl } from '@/utils/baseUrl.js'
export const common = {
	data() {
		return {
			selectList: [{
					label: '全部',
					value: '',
					color: '#909399'
				},
				{	label: '已上架',
					value: 1,
					color: '#5ADDB3'
				},
				{
					label: '已下架',
					value: -2,
					color: '#909399'
				},
				{
					label: '已驳回',
					value: 2,
					color: '#EC4561'
				},
				{
					label: '审核中',
					value: 3,
					color: '#FFA555'
				},
				{
					label: '草稿',
					value: 4,
					color: '#909399'
				},
				// {
				// 	label: '下架待审核',
				// 	value: 5
				// }
			],
			commonMixin_ksClassKuStatusList: [ // 快手课程库状态列表
				{
					label: '全部',
					value: '',
				},
				{
					label: '审核通过',
					value: 2,
				},
				{
					label: '审核驳回',
					value: 3,
				},
				{
					label: '审核中',
					value: 4,
				},
				{
					label: '待推送',
					value: 1,
				}
			],
			isVideoObj: {
				1: '',
				2: ''
			},
			durationObj: {
				1:0,
				2: 0
			},
			sessionFileName: '',
			dialogVisible: false,
			editParams: {},
			row: '',
			messageOption: '',
			watchMoreFlag: false,
			noDataName: 'empty',
			releaseTypeList: [
				{
					label: '抖音',
					value: 1,
					includesList: ['/']
				},
				{
					label: '快手',
					value: 2,
					includesList: ['/', '/ks/']
				},
				{
					label: '微信',
					value: 3,
					includesList: ['/wx/']
				},
			],
		}
	},
	components: {
		'submit-dialog': submitDialog
	},
	methods: {
		...mapActions('createClass', ['userGetCode']),
		...mapActions('withdrawal', ['EditProductSort']),
		...mapMutations(['cancelRouter']),
		getUploadFileObj() {
			this.sessionFileName = this.$route.name + 'FileName' + this.$route.params.id
			let fileNameObj = sessionStorage.getItem(this.sessionFileName) && JSON.parse(sessionStorage.getItem(this.sessionFileName))
			if(fileNameObj && Object.values(fileNameObj).length) {
				this.isVideoObj = fileNameObj.isVideoObj
				this.durationObj = fileNameObj.durationObj
			}
		},
		setUrlAndDuration(value) {
			this.ruleForm.url = this.uploadObj[value].url || ''
			this.ruleForm.duration = this.uploadObj[value].duration || 0
		},
		goBack(fn, path) {
			console.log(this.backTitFlag, 'ooooooooooooooooooo2222222')
			if (this.backTitFlag) {
				this.cancelRouter(true)
				this.$confirm('正在离开页面，将保存当前页面编辑的信息为草稿。', '提示', {
					distinguishCancelAndClose: false,
					showCancelButton: false,
					closeOnClickModal: false,
					closeOnPressEscape: false,
					confirmButtonText: '确定',
					customClass: this.classNames + '_common_dialog',
					center: true
				}).then(() => {
					fn(true)
					// console.log(path, 'ooooooooooooo')
					
					// this.saveDraft('ruleForm')
					// this.$router.go(-1)
				})
			} else {
				this.cancelRouter('')
				fn(false)
			}
		},
		domToImage(row) {
			let dom = document.getElementById(row.id)
				html2canvas(dom, {
					useCORS: true
				}).then(canvas => {
				let link = document.createElement("a");
				link.href = canvas.toDataURL();//下载链接
				link.download = row.title+ '.png'
				link.style.display = "none";//a标签隐藏
				document.body.appendChild(link);
				link.click();
			})
		},
		mouseover(e, row) {
			console.log(e.target)
			this.$set(row, 'shareVisible', true)
		},
		mouseout(e,row) {
			console.log(e.target)
			this.$set(row, 'shareVisible', false)
		},
		async popoverShow(row) {
			let token = localStorage.getItem('token')
			let timeStamp = Date.now()
			const instance = axios.create({
				baseURL: getBaseUrl(),
				headers: {
					times: timeStamp,
					sign: md5(timeStamp + token),
					token: token
				}
			})
			this.$set(row, 'loading', true)
			instance.post('/user/user/getcode', {id: row.id}).then(res => {
				this.$set(row, 'loading', false)
				this.$set(row, 'codeUrl', 'data:image/jpeg;base64,' +  res.data.data)
			}).catch(error=> {
				throw error(error)
			})
		},
		handleShow(value, type) {
			if(value === ''){
				return
			}
			let obj = {
				'-1':[-2,4,2],
				1:[1], // 下架
				2:[-2, 2], // 上架
				3:[-2, 1,2,4], // 编辑
				4: [3, 5], // 查看
				5:[1, -2,5], // 分享
				6:[3,5], // 章节撤回
				7:[3], // 专栏撤回
				'wx': [0] // 同步微信
			}
			if(obj[type].includes(value)) {
				return true
			} 		
		},
		debounce(fn, times, flag = true) {
			if(this.timer) {
				clearTimeout(this.timer)
			}
			this.timer = setTimeout(fn,times)
		},
		upEdit(title) {
			this.$confirm(`请先下架，才能编辑${title}`, '提示', {
				distinguishCancelAndClose: false,
				confirmButtonText: '确定',
				showCancelButton: false,
				customClass: this.classNames + '_common_dialog',
				center: true
			})
			return false
		},
		watchMore() {
			this.watchMoreFlag = !this.watchMoreFlag
		},
		cellClassName({ column }) {
			if(column.label == '操作') {
				return 'td-flex'
			} else {
				return ''
			}
		},
		editSort(row) {
			this.$set(row, 'sortFlag', true)
			this.$nextTick(() => {
				console.log(this.$refs['inp'+ row.id], '....thisthisthis')
				this.$refs['inp'+ row.id].focus()
				console.log(this.$refs['inp'+ row.id][0], '...7787ds')
			})
		},
		async editSortSave(row, type) {
			if(!row.sort) {
				return
			}
			await this.EditProductSort({id: row.id, sort: row.sort})
			this[type]()
			this.$message({
				type: 'success',
				message: '修改成功',
				duration: 3000
			})
			this.$set(row, 'sortFlag', false)
		},
		changeSort(row) {
			console.log(row.sort, '...row.sort')
			this.$set(row, 'sort', row.sort.replace(/[^0-9]/g, ''))
			if (row.sort < 0 || row.sort > 200) {
				this.$set(row, 'sort', row.sort.slice(0,row.sort.length - 1))
			}
		},
	},
	filters: {
		handleStatus(value) {
			switch(value) { 
				case -2:
					return '下架'
				case -1:
					return ''
				case 1:
					return '上架'
				case 2:
					return '驳回'
				case 3:
					return '审核中'
				case 4:
					return '草稿'
				// case 5:
				// 	return '下架待审核'
				default:
					return ''
			}
		}
	},
	directives: {
		statusColor: {
			bind(el, binding) {
				let {status, list} = binding.value
				let obj = list.find(item => item.value == status)
				el.style.border=`1px solid ${obj.color}`
				el.style.color=obj.color
				el.innerHTML = obj ? obj.label: ''
			},
			update(el,binding) {
				let {status, list} = binding.value
				let obj = list.find(item => item.value == status)
				el.style.border=`1px solid ${obj.color}`
				el.style.color=obj.color
				el.innerHTML = obj ? obj.label: ''
			}
		}
	}
}
